export const PHONE_NUMBER = 11;
export const ID = 8;
export const PASSPORT = 12;
export const PRICE = 5;
export const EMAIL = 50;
export const PASSWORD = 50;
export const NAME = 50;
